import TileLayer from "ol/layer/Tile";
import { TileWMS } from "ol/source";
// import { buildCQLFilter } from "../../../../../../services/MapCore/MapCQLFilterService";
// import { DefaultWfsLayer } from "../../DefaultLayerGroup/Layers/DefaultWfsLayer";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Circle, Fill, Stroke, Style } from "ol/style";
import { Select } from "ol/interaction";
import { GeoJSON } from "ol/format";
import { click } from "ol/events/condition";
import Photo from "ol-ext/style/Photo"; // Importa ol.style.Photo de ol-ext
// import authService from "../../../../../../services/AuthService";
import { WfsLayer } from "./WfsLayer";
import { buildCQLFilter } from "../../services/MapCore/MapCQLFilterService";
import authService from "../../services/AuthService";

const zoomThreshold = 17; // Define el nivel de zoom donde cambiará el estilo

class TreeCoverLayer extends WfsLayer {
  constructor(layer_data, layer_group_id, map) {
    super(layer_data, layer_group_id);

    this.id = this.id.replace(layer_data.uuid, `treecover-${layer_data.uuid}`);

    const zoomLevel = map.getView().getZoom();
    this.isShowingPictures = zoomLevel > zoomThreshold;
    this.map = map;
    this.filters = [
      { key: "layer_uuid", values: [layer_data.uuid], operation: "AND" },
    ];
    this.layer = this.createLayer();
  }

  createLayer = () => {
    const { geoserver_layer_id } = this.layer_data;

    const getFeatureStyle = (feature, selected = false) => {
      return new Style({
        image: new Photo({
          src: feature.get("image_url"),
          radius: 20,
          shadow: true,
          crop: true,
          kind: "anchored",
          offsetY: -18,
          stroke: new Stroke({
            color: selected ? "red" : "white",
            width: selected ? 5 : 3,
          }),
        }),
      });
    };

    const token = authService.getToken(); // Obtener el token desde tu sistema de autenticación

    const cqlFilter = buildCQLFilter(this.filters);

    const url =
      "https://ag4city.agforest.ai/api/geoserver/private/ows?" +
      "service=WFS&" +
      "version=2.0.0&" +
      "request=GetFeature&" +
      "typename=" +
      geoserver_layer_id +
      "&outputFormat=application/json&" +
      "srsname=EPSG:4326&" +
      "CQL_FILTER=" +
      encodeURIComponent(cqlFilter);

    const vectorSource = new VectorSource({
      loader: function (extent, resolution, projection) {
        fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`, // Incluir el token en los headers
          },
        })
          .then((response) => response.json())
          .then((data) => {
            const features = new GeoJSON().readFeatures(data, {
              dataProjection: "EPSG:4326", // Proyección de los datos
              featureProjection: projection.getCode(), // Proyección del mapa
            });

            vectorSource.clear(); // Limpiar datos anteriores
            vectorSource.addFeatures(features); // Agregar nuevas features
          })
          .catch((error) =>
            console.error("Error cargando datos GeoJSON:", error)
          );
      },
    });

    // const zoomThreshold = 15; // Define el nivel de zoom donde cambiará el estilo

    const new_layer = new VectorLayer({
      id: this.id,
      source: vectorSource,
      style: (feature) => {
        // const zoomLevel = this.map.getView().getZoom(); // Obtiene el nivel de zoom actual

        if (this.isShowingPictures) {
          return getFeatureStyle(feature);
        } else {
          return new Style({
            image: new Circle({
              radius: 3,
              fill: new Fill({ color: "rgba(139,240,150,255)" }), // Color del punto
              stroke: new Stroke({ color: "black", width: 1 }), // Borde del punto
            }),
          });
        }
      },
    });

    // Control Select
    var select = new Select({
      // condition: op.events.condition.click,
      condition: click,
      style: function (feature) {
        return getFeatureStyle(feature, true);
      },
    });
    this.map.addInteraction(select);

    this.map.getView().on("change:resolution", () => {
      const zoomLevel = this.map.getView().getZoom();

      const newIsShowingPictures = zoomLevel > zoomThreshold;

      if (newIsShowingPictures !== this.isShowingPictures) {
        this.isShowingPictures = newIsShowingPictures;
        this.layer.changed();
      }
    });

    return new_layer;
  };
}

export { TreeCoverLayer };
